import {AppFunction} from "../misc/types";
import View from "../framework/view";
import {ShopProductsView} from "../views/shop_products";
import {ShopProductView} from "../views/shop_product";
import { ShopCollectionsView } from "../views/shop_collections";
import {ShopCollectionView} from "../views/shop_collection";

export class ShopProductsFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new ShopProductsView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/shop/products`;
    }
}

export class ShopProductFunction extends AppFunction {

    private name: string;

    readonly v : View;

    constructor(name: string) {
        super();
        this.name = name;
        this.v = new ShopProductView(name);
    }

    view() {
        return this.v;
    }

    url() {
        return `/shop/product/${encodeURIComponent(this.name)}`;
    }
}

export class ShopCollectionsFunction extends AppFunction {

    readonly v : View;

    constructor() {
        super();
        this.v = new ShopCollectionsView();
    }

    view() {
        return this.v;
    }

    url() {
        return `/shop/collections`;
    }
}

export class ShopCollectionFunction extends AppFunction {

    private name: string;

    readonly v : View;

    constructor(name: string) {
        super();
        this.name = name;
        this.v = new ShopCollectionView(name);
    }

    view() {
        return this.v;
    }

    url() {
        return `/shop/collection/${encodeURIComponent(this.name)}`;
    }
}

